<script setup lang="ts">
import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
import { initGTMFromComponent } from '@/helpers/initGTM';

const onAccept = () => {
  console.log('User accepted cookies');
  localStorage.setItem('cookiesAccepted', 'true');
  initGTMFromComponent();
};

const onDecline = () => {
  console.log('User declined cookies');
};

const onStatus = (status: string | null) => {
  console.log('[CookieConsent] Cookie status is:', status ?? 'null (no decision yet)');
};
</script>

<template>
  <VueCookieAcceptDecline
    element-id="cookie-consent-banner"
    :debug="false"
    :disable-decline="false"
    :show-postpone-button="false"
    @clicked-accept="onAccept"
    @clicked-decline="onDecline"
    @status="onStatus"
  >
    <template #message>
      Utilizamos cookies para garantizar que obtengas la mejor experiencia en nuestro sitio web.
      <a href="/cookies-policy" 
            target="_blank"
            class="btn-secondary-s btn-underline-black more-cookies">
            Aprende más...
      </a>
    </template>
    <template #acceptContent>Aceptar</template>
    <template #declineContent>Rechazar las no esenciales</template>
  </VueCookieAcceptDecline>
</template>

<style lang="scss">
@import 'CookieConsentComponent.scss';
</style>